import { z } from 'zod';
import { OffsetPaginationParamsSchema } from '../offset-pagination.js';
// ---------------------------------------------------------------------------
// Personnel contact cards (REQ-016, 022). PII fields are encrypted at rest
// (ADR-012) — schemas see PLAINTEXT values; encryption happens in the API
// layer. last/first name required at the API level (DB columns are nullable
// because they hold ciphertext).
// ---------------------------------------------------------------------------
export const PersonnelDetailsDtoSchema = z.object({
    id: z.number().int().positive(),
    tenantId: z.number().int().positive(),
    lastName: z.string().min(1).max(255).nullable(),
    firstName: z.string().min(1).max(255).nullable(),
    phoneMobile: z.string().max(50).nullable(),
    phone2: z.string().max(50).nullable(),
    email1: z.email('Niepoprawny format adresu e-mail').max(320).nullable(),
    email2: z.email('Niepoprawny format adresu e-mail').max(320).nullable(),
    phone2Comments: z.string().nullable(),
    email1Comments: z.string().nullable(),
    email2Comments: z.string().nullable(),
    comments: z.string().nullable(),
    // non-PII flag: in-house (internal) staff vs external person (mail 6, P8)
    internalPersonnel: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const CreatePersonnelDetailsRequestSchema = z.object({
    lastName: z.string().min(1, 'Nazwisko jest wymagane').max(255),
    firstName: z.string().min(1, 'Imię jest wymagane').max(255),
    phoneMobile: z.string().max(50).optional(),
    phone2: z.string().max(50).optional(),
    email1: z.email('Niepoprawny format adresu e-mail').max(320).optional(),
    email2: z.email('Niepoprawny format adresu e-mail').max(320).optional(),
    phone2Comments: z.string().max(10_000).optional(),
    email1Comments: z.string().max(10_000).optional(),
    email2Comments: z.string().max(10_000).optional(),
    comments: z.string().max(10_000).optional(),
    internalPersonnel: z.boolean().optional(),
});
export const UpdatePersonnelDetailsRequestSchema = z.object({
    lastName: z.string().min(1).max(255).optional(),
    firstName: z.string().min(1).max(255).optional(),
    phoneMobile: z.string().max(50).nullable().optional(),
    phone2: z.string().max(50).nullable().optional(),
    email1: z.email('Niepoprawny format adresu e-mail').max(320).nullable().optional(),
    email2: z.email('Niepoprawny format adresu e-mail').max(320).nullable().optional(),
    phone2Comments: z.string().max(10_000).nullable().optional(),
    email1Comments: z.string().max(10_000).nullable().optional(),
    email2Comments: z.string().max(10_000).nullable().optional(),
    comments: z.string().max(10_000).nullable().optional(),
    internalPersonnel: z.boolean().optional(),
});
export const PersonnelListQuerySchema = OffsetPaginationParamsSchema.extend({
    search: z.string().max(100).optional(),
    internalPersonnel: z
        .enum(['true', 'false'])
        .transform((value) => value === 'true')
        .optional(),
});
//# sourceMappingURL=personnel.schema.js.map